import React, { useEffect, useState, useRef } from 'react'

import useAuth from '../../auth/useAuth';

import {
    settings, setSeparatorsNumbersNew, getProcessButtons, getDtRowIndex, setDateTimeFormatGlobal, checkDecimalPlacesNew, setNumberNew,
    sendMessageCloseCurrentWindow, isUndNullEmpNew, getError, isUndNullNew, getLanguageObj, getResponse, LoadingSection, numberTruncatorNew
} from '../../helpers/UtilsHelper';

import Menu from '../main/Menu';
import SaleEditDetails from './SaleEditDetails';
import Swal from 'sweetalert2';
import { UserClass } from '../../classes/user/userClass';
import { UserService } from '../../services/users/UserService';
import { SaleService } from '../../services/sales/SaleService';
import { SwalPropertiesClass } from '../../classes/main/swalPropertiesClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import TableIndex from '../main/TableIndex';

const { app, colors, firebase, html, icons, messages, mercadoLibre, labels, react, } = settings;
const { feedback: mercadoLibreFeedback, } = mercadoLibre;
const { fields: dbFields, operators: dbOperators, ordersBy: dbOrdersBy, } = firebase?.firestore;
const { sweetAlert2, } = react;
const { urls } = app?.backend;

const $ = window?.$;

const currentMethod = 'Sales - function';

export default function Sales({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    let swalProperties = SwalPropertiesClass?.getClass();
    const selUsersId = 'selUsers';
    const btnProcessId = 'btnProcess';
    const [user, setUser] = useState({});
    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState(setFormDataInit());
    const [process, setProcess] = useState({ showLoading: false });
    const isMount = useRef(true);
    const [isSelected, setIsSelected] = useState(false);
    const dateTimeFormat = {
        date: languageObj?.format?.date?.f1,
        time: languageObj?.format?.time?.type,
    };
    //#region sales
    const dtSalesId = 'dtSales';
    const [sales, setSales] = useState([]);
    const [saleTotals, setSaleTotals] = useState({ quantity: 0.00, price: 0.00, priceOC: 0.00 });
    const [showModal, setShowModal] = useState(false);
    const [saleEdited, setSaleEdited] = useState(setSaleEditedInit());
    //#endregion sales
    //#endregion variables

    //#region sales (methods)
    function setFormDataInit() {
        return { firstName: '', lastName: '', secondId: 0, email: '', rate: 0, items: 0, };
    }

    function setSaleEditedInit() {
        return { id: 0, description: '', rowIndex: 0, type: 0, sale: {}, sales: [], user: {}, };
    }

    //#region old code
    // const setRating = ({
    //     data = '',
    //     subMethod = '',
    // }) => {
    //     const currentMethod = 'setRating';
    //     let response = getResponse({ type: 0 });
    //     try {
    //         //#region variables
    //         //#endregion variables

    //         //#region process
    //         if (!isUndNullEmpNew({ data: data, subMethod: currentMethod, })?.result) {
    //             switch (data) {
    //                 case mercadoLibreFeedback?.ratings?.negative:
    //                     response.result = `${icons?.fasFa?.minusCircle} text-danger`;
    //                     break;
    //                 case mercadoLibreFeedback?.ratings?.neutral:
    //                     response.result = `${icons?.fasFa?.pauseCircle} text-info`;
    //                     break;
    //                 case mercadoLibreFeedback?.ratings?.positive:
    //                     response.result = `${icons?.fasFa?.plusCircle} text-success`;
    //                     break;
    //                 case '':
    //                     response.result = `${icons?.fasFa?.stopCircle} text-secondary`;
    //                     break;
    //                 default:
    //                     break;
    //             }
    //         } else {
    //             response.result = `${icons?.fasFa?.stopCircle} text-secondary`;
    //         }
    //         //#endregion process
    //     } catch (ex) {
    //         response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    //         console?.error(response);
    //     }
    //     return response;
    // }
    //#endregion old code
    const setRating = ({
        data = {
            purchase: { rating: '', },
            sale: { rating: '', },
        },
        subMethod = '',
    }) => {
        const currentMethod = 'setRating';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let iconFeedback = `<span style="font-size: 0.75rem;"><i class="sale"></i> / <i class="purchase"></i></span>`
            //#endregion variables

            //#region process
            if (!isUndNullEmpNew({ data: data, subMethod: currentMethod, })?.result) {
                const { purchase, sale } = data;
                if (purchase?.rating) {
                    switch (purchase?.rating) {
                        case mercadoLibreFeedback?.ratings?.negative:
                            iconFeedback = iconFeedback.replace('purchase', `${icons?.fasFa?.minusCircle} text-danger`);
                            response.result = iconFeedback;
                            break;
                        case mercadoLibreFeedback?.ratings?.neutral:
                            iconFeedback = iconFeedback.replace('purchase', `${icons?.fasFa?.pauseCircle} text-info`);
                            response.result = iconFeedback;
                            break;
                        case mercadoLibreFeedback?.ratings?.positive:
                            iconFeedback = iconFeedback.replace('purchase', `${icons?.fasFa?.plusCircle} text-success`);
                            response.result = iconFeedback;
                            break;
                        case '':
                            iconFeedback = iconFeedback.replace('purchase', `${icons?.fasFa?.stopCircle} text-secondary`);
                            response.result = iconFeedback;
                            break;
                        default:
                            break;
                    }
                }

                if (sale?.rating) {
                    switch (sale?.rating) {
                        case mercadoLibreFeedback?.ratings?.negative:
                            iconFeedback = iconFeedback.replace('sale', `${icons?.fasFa?.minusCircle} text-danger`);
                            response.result = iconFeedback;
                            break;
                        case mercadoLibreFeedback?.ratings?.neutral:
                            iconFeedback = iconFeedback.replace('sale', `${icons?.fasFa?.pauseCircle} text-info`);
                            response.result = iconFeedback;
                            break;
                        case mercadoLibreFeedback?.ratings?.positive:
                            iconFeedback = iconFeedback.replace('sale', `${icons?.fasFa?.plusCircle} text-success`);
                            response.result = iconFeedback;
                            break;
                        case '':
                            iconFeedback = iconFeedback.replace('sale', `${icons?.fasFa?.stopCircle} text-secondary`);
                            response.result = iconFeedback;
                            break;
                        default:
                            break;
                    }
                }

                if (!purchase?.rating || !sale?.rating) {
                    iconFeedback = iconFeedback?.replaceAll('purchase', `${icons?.fasFa?.stopCircle} text-secondary`);
                    iconFeedback = iconFeedback?.replaceAll('sale', `${icons?.fasFa?.stopCircle} text-secondary`);
                    response.result = iconFeedback;
                }
            } else {
                iconFeedback = iconFeedback?.replaceAll('purchase', `${icons?.fasFa?.stopCircle} text-secondary`);
                iconFeedback = iconFeedback?.replaceAll('sale', `${icons?.fasFa?.stopCircle} text-secondary`);
                response.result = iconFeedback;
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console?.error(response);
        }
        return response;
    }

    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let dt_ = {};
            let dtRows = {};
            //#endregion variables

            //#region datatable
            dt_ = $(`#${dtSalesId}`).DataTable({
                destroy: true,
                data: [],
                //order: [[2, 'desc']],
                order: [[0, 'desc']],
                columns: [
                    { title: labels?.date?.[languageObj?.id], width: '0%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.code?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.title?.[languageObj?.id], width: '46%', orderable: true, },
                    {
                        title: labels?.status?.[languageObj?.id],
                        className: 'text-center',
                        width: '4%',
                        orderable: true,
                        render: (data, type, row) => {
                            let data_ = ``;
                            // // data_ = `<i class="${setRating({ data: data?.rating, subMethod: currentMethod, })?.result}"></i>`
                            // data_ = `<i class="${setRating({ data: data, subMethod: currentMethod, })?.result}"></i>`
                            data_ = setRating({ data: data, subMethod: currentMethod, })?.result;
                            return data_;
                        },
                    },
                    { title: labels?.date?.[languageObj?.id], width: '10%', orderable: true, },
                    { title: labels?.quantity?.[languageObj?.id], className: 'text-right', width: '7%', orderable: true, },
                    { title: labels?.priceOC?.[languageObj?.id], className: 'text-right', width: '8%', orderable: true, },
                    { title: labels?.price?.[languageObj?.id], className: 'text-right', width: '10%', orderable: true, },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                    //{ title: 'Id', width: '5%', searchable: false, orderable: true, visible: false, },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            });
            dt_.buttons().container().appendTo(`#${dtSalesId}_wrapper .col-md-6:eq(0)`);
            dt_.on('search.dt', () => {
                dtRows = dt_.rows({ search: 'applied' }).data();
                if (!isUndNullEmpNew({ data: dtRows, subMethod: currentMethod, })?.result) {
                    response = getTotals({ dtId: dtSalesId, dtRows: dtRows, subMethod: currentMethod });
                    if (!response?.isSuccess || response?.isWarning) return response;
                }
            });
            //#endregion datatable

            //#region query code set
            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return response;
            //#endregion query code set
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getTotals = ({
        dtId = '',
        dtRows = [],
        subMethod = '',
    }) => {
        const currentMethod = 'getTotals';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let priceStrLocal = '';
            let priceOCStrLocal = '';
            let quantityStrLocal = '';
            let priceLocal = 0.00;
            let priceOCLocal = 0.00;
            let quantityLocal = 0.00;
            let priceOCTotalLocal = 0.00;
            let priceTotalLocal = 0.00;
            let quantityTotalLocal = 0.00;
            //#endregion variables

            //#region process
            if (!isUndNullEmpNew({ data: dtRows, subMethod: currentMethod, })?.result && dtRows?.length > 0) {
                for (let iLocal = 0; iLocal < dtRows?.length; iLocal++) {
                    if (dtRows?.[iLocal]?.[3]?.fulfilled === true &&
                        dtRows?.[iLocal]?.[3]?.rating === settings?.mercadoLibre?.feedback?.ratings?.positive) {
                        quantityStrLocal = dtRows?.[iLocal]?.[5].replaceAll(',', '');
                        quantityLocal = setNumberNew({
                            number: quantityStrLocal,
                            type: 'd',
                            subMethod: currentMethod
                        })?.result;
                        quantityTotalLocal += checkDecimalPlacesNew({
                            number: quantityLocal,
                            subMethod: currentMethod
                        })?.result;

                        priceOCStrLocal = dtRows?.[iLocal]?.[6].replaceAll(',', '');
                        priceOCLocal = setNumberNew({
                            number: priceOCStrLocal,
                            type: 'd',
                            subMethod: currentMethod
                        })?.result;
                        priceOCTotalLocal += checkDecimalPlacesNew({
                            number: priceOCLocal,
                            subMethod: currentMethod
                        })?.result;

                        priceStrLocal = dtRows?.[iLocal]?.[7].replaceAll(',', '');
                        priceLocal = setNumberNew({
                            number: priceStrLocal,
                            type: 'd',
                            subMethod: currentMethod
                        })?.result;
                        priceTotalLocal += checkDecimalPlacesNew({
                            number: priceLocal,
                            subMethod: currentMethod
                        })?.result;
                    }
                }
            }

            setSaleTotals({
                quantity: numberTruncatorNew({
                    number: quantityTotalLocal,
                    subMethod: currentMethod
                })?.result,
                price: numberTruncatorNew({
                    number: priceTotalLocal,
                    subMethod: currentMethod
                })?.result,
                priceOC: numberTruncatorNew({
                    number: priceOCTotalLocal,
                    subMethod: currentMethod
                })?.result,
            });
            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const clearDataTable = ({
        dtSales = false,
        subMethod = '',
    }) => {
        const currentMethod = 'clearDataTable';
        let response = getResponse({ type: 0 });
        try {
            if (dtSales) $(`#${dtSalesId}`).DataTable().rows().remove().draw(true);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id = '';
            let rowIndex = 0;
            let description = '';
            let methodValue = '';
            //#endregion variables

            //#region process
            $(`#${dtSalesId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowIndex = getDtRowIndex(dtSalesId, this, currentMethod)?.result;
                if (!isUndNullNew({ data: rowIndex, subMethod: currentMethod, })?.result) {
                    methodValue = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodValue) {
                        case 'edit':
                            setSaleEditDetailDelete({
                                e: e,
                                id: id,
                                description: description,
                                rowIndex: rowIndex,
                                processType: 1,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'delete':
                            setSaleEditDetailDelete({
                                e: e,
                                id: id,
                                description: description,
                                rowIndex: rowIndex,
                                processType: -1,
                                subMethod: currentMethod,
                            });
                            break;
                        case 'details':
                            setSaleEditDetailDelete({
                                e: e,
                                id: id,
                                description: description,
                                rowIndex: rowIndex,
                                processType: 2,
                                subMethod: currentMethod,
                            });
                            break;
                        default:
                            break;
                    }
                }
            });

            //#endregion process
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            //#region get data (users)
            const dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: auth?.account?.uid, },
                ],
                ordersBy: [
                    { field: dbFields?.userName, value: dbOrdersBy?.asc, },
                ]
            };

            response = await UserService.getUsers({
                token: auth?.account?.tokenVzLaML?.token,
                data: dataObj,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            setUsers(response?.result || []);
            //#endregion get data (users)
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getUserAndSalesByUserIdAsync = async ({
        userId = '',
        subMethod = '',
    }) => {
        const currentMethod = 'getUserAndSalesByUserIdAsync';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));
            //#region variables
            let sales_ = {};
            let salesDt = [];
            let user_ = UserClass?.getClass();
            //#endregion variables

            setUser({});
            setSales([]);
            setIsSelected(false);

            //#region clear dataTables
            response = clearDataTable({ dtSales: true, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion clear dataTable

            //#region process
            if (!isUndNullEmpNew({ data: userId, subMethod: currentMethod, })?.result) {
                //#region get user
                user_ = users.filter(({ id }) => id === userId)[0];

                if (user_ !== undefined && user_ !== null && user_.length > 0) {
                    user_ = user_?.[0] || user_;
                }
                //#endregion get user

                //#region check status user
                setUser(user_);
                setIsSelected(true);

                if (isUndNullEmpNew({ data: user_?.code, subMethod: currentMethod, })?.result || user_?.secondId === 0) {
                    setIsSelected(false);
                    response = getResponse({ type: 1, msgText_: settings?.errors?.users?.newNotCode?.[languageObj?.id] });
                    return;
                }
                //#endregion check status user

                //#region get data (sales)
                const dataObj = {
                    conditionals: [
                        { field: 'seller.id', operator: dbOperators?.equal, value: user_?.secondId, },
                    ],
                    ordersBy: [
                        { field: dbFields?.date_created, value: dbOrdersBy?.desc, },
                    ],
                    getItemDetails: true,
                    limit: 0,
                };

                response = await SaleService.postQuery({
                    token: auth?.account?.tokenVzLaML?.token,
                    dataObj: dataObj,
                    subMethod: currentMethod
                });
                if (!response?.isSuccess || response?.isWarning) return;

                sales_ = response?.result;

                setFormData({
                    ...formData,
                    firstName: user_.firstName,
                    lastName: user_.lastName,
                    email: user_.email,
                    secondId: user_.secondId,
                });
                //#endregion get data (sales)

                //#region set dataTable data
                if (!isUndNullEmpNew({ data: sales_, subMethod: currentMethod, })?.result) {
                    setSales(sales_);
                    salesDt = sales_.map((detail) => {
                        const sale_ = detail.order_items?.[0];
                        return [
                            detail.date_created,
                            sale_.item.id,
                            sale_.item.title,
                            //#region old code
                            // {
                            //     fulfilled: detail?.feedbackFull?.sale?.fulfilled,
                            //     rating: detail?.feedbackFull?.sale?.rating,
                            //     reason: detail?.feedbackFull?.sale?.reason,
                            // },
                            //#endregion old code
                            {
                                purchase: detail?.feedbackFull?.purchase,
                                sale: detail?.feedbackFull?.sale,
                            },
                            setDateTimeFormatGlobal({
                                date: detail.date_created,
                                type: dateTimeFormat?.date,
                                // format: dateTimeFormat?.time,
                                format: 0,
                                addTime: false,
                                withSeconds: false,
                                subMethod: currentMethod
                            })?.result,
                            setSeparatorsNumbersNew({
                                number: sale_.quantity,
                                withDecimals: true,
                                subMethod: currentMethod
                            })?.result,
                            setSeparatorsNumbersNew({
                                number: sale_.full_unit_price,
                                withDecimals: true,
                                subMethod: currentMethod
                            })?.result,
                            setSeparatorsNumbersNew({
                                number: sale_.unit_price,
                                withDecimals: true,
                                subMethod: currentMethod
                            })?.result,
                            getProcessButtons({
                                id: detail.id,
                                description: sale_.item.title,
                                detailsShow: true,
                                detailsLabel: labels?.detail?.[languageObj?.id],
                                detailsEnabled: true,
                                editShow: false,
                                editLabel: labels?.edit?.[languageObj?.id],
                                editEnabled: false,
                                deleteShow: true,
                                deleteLabel: labels?.delete?.[languageObj?.id],
                                deleteEnabled: true,
                                processButtons: [],
                                languageId: languageObj?.id,
                                subMethod: currentMethod
                            })?.result,
                        ];
                    });
                }

                $(`#${dtSalesId}`).DataTable().rows.add(salesDt).draw(true);
                //#endregion set dataTable data
            } else {
                setFormData(setFormDataInit());
                setIsSelected(false);
                setUser({});
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setSaleEditDetailDelete = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'setSaleEditDetailDelete';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            //#region variables
            //let saleLocal = {};
            //#endregion variables

            setSaleEdited(setSaleEditedInit());

            //#region get data (local)
            setSaleEdited({ id: id, description, rowIndex, type: processType, sale: {}, sales: sales, user: user });
            $(`#${btnProcessId}`).trigger('click');
            //#endregion get data (local)
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getSaleEditDetailDelete = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getSaleEditDetailDelete';
        let response = getResponse({ type: 0 });
        try {
            if (saleEdited?.type !== -1) {
                setProcess(prev => ({ ...prev, showLoading: true }));
            }
            //#region variables
            let sale_ = {};
            //#endregion variables

            //#region get data (local)
            sale_ = sales.filter(({ id, }) => id === saleEdited?.id);
            saleEdited.sale = sale_?.[0] || sale_;
            saleEdited.sales = sales;
            saleEdited.user = user;
            //#endregion get data (local)

            if (saleEdited?.type !== -1) {
                setProcess(prev => ({ ...prev, showLoading: false }));
            }

            //#region show modal
            if (!isUndNullNew({ data: saleEdited?.type, subMethod: currentMethod, })?.result &&
                (saleEdited?.type === 1 || saleEdited?.type === 2)) {
                // await awaitDelay({ delay: settings.timers.threeNanoSeconds });
                setShowModal(true);
            }
            //#endregion show modal

            //#region delete data (sale)
            if (saleEdited?.type === -1) {
                //#region show message
                let msgTextObj = {
                    one: messages?.areYouSureDeleteThis?.[languageObj?.id],
                    two: `${labels?.sale?.[languageObj?.id]}: <b>${saleEdited?.description}</b><br/>`,
                    three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                };

                swalProperties = {
                    icon: sweetAlert2?.icons?.warning,
                    title: msgTextObj?.one,
                    html: `${msgTextObj?.two}${msgTextObj?.three}`,
                    timer: null,
                    backdrop: true,
                    confirmButtonColor: colors?.warningColorExp,
                    confirmButtonText: labels?.yes?.[languageObj?.id],
                    showCancelButton: true,
                    cancelButtonColor: colors?.successColorExp,
                    cancelButtonText: labels?.no?.[languageObj?.id],
                    showLoaderOnConfirm: true,
                    customClass: {
                        popup: html?.popup,
                        confirmButton: html?.buttons?.primary,
                        cancelButton: html?.buttons?.secondary,
                    },
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                    allowOutsideClick: () => !Swal?.isLoading(),
                    preConfirm: async () => {
                        let preConfirmResponse = getResponse({ type: 0 });
                        try {
                            Swal.getCancelButton().hidden = true;
                            Swal.update({
                                icon: sweetAlert2?.icons?.info,
                                title: `${messages?.processing?.[languageObj?.id]}`,
                                html: `${msgTextObj?.two}`,
                                showConfirmButton: false,
                            });

                            //#region delete data (sale)
                            preConfirmResponse = await SaleService.deleteById({
                                id: saleEdited?.id,
                                token: auth?.account?.tokenVzLaML?.token,
                                subMethod: currentMethod
                            });
                            if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                            $(`#${dtSalesId}`).DataTable().row(saleEdited?.rowIndex).remove().draw(true);

                            preConfirmResponse.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
                            //#endregion delete data (sale)
                        } catch (ex) {
                            preConfirmResponse = getError({ ex: ex, response: preConfirmResponse, currentMethod_: currentMethod, subMethod_: subMethod });
                        }
                        return preConfirmResponse;
                    }
                };

                const swalresult = await Swal.fire({ ...swalProperties });
                if (swalresult?.isConfirmed && swalresult?.value) {
                    response = swalresult?.value;
                } else if (swalresult?.isDismissed) {
                    response = getResponse({ type: 0 });
                }
                //#endregion show message
            }
            //#endregion delete data (sale)
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            // if (saleEdited?.type !== -1) {
            //     setProcess(prev => ({ ...prev, showLoading: false }));
            // }

            if (saleEdited?.type !== -1) {
                setProcess(prev => ({ ...prev, showLoading: false }));
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }
    //#endregion sales (Methods)

    //#region process (others)
    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion process (others)

    return (
        <div>
            <Menu viewName={'sales'} process={'sales'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {labels?.sales?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home} className='link-primary-bold'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.sales?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className={settings?.html?.cards?.default} >
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.account?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.info} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.account?.[languageObj?.id]}</h5>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={settings?.icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body pt-0'>

                                        <div className='row'>
                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {messages?.selectUser?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <select className='form-control border-0 shadow-sm form-input-icon custom-select'
                                                            id={selUsersId}
                                                            onChange={(e) => getUserAndSalesByUserIdAsync({ userId: e?.target?.value, subMethod: 'selectUser', })}>
                                                            <option defaultValue value=''>{messages?.selectUser?.[languageObj?.id]}</option>
                                                            {users.length > 0 ?
                                                                users.map((user) => (
                                                                    <option key={user?.id} value={user?.id}>{` ${user?.userName}`}</option>
                                                                ))
                                                                :
                                                                null
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.firstName?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            placeholder={labels?.firstName?.[languageObj?.id]}
                                                            value={formData.firstName}
                                                            title={labels?.firstName?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.secondId?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.fasFa?.idCard} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            placeholder={labels?.secondId?.[languageObj?.id]}
                                                            value={formData.secondId}
                                                            title={labels?.secondId?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-12 col-md-4' hidden={true}>
                                                <div className='form-group text-right'>
                                                    <button className='btn btn-outline-success btn-sm'
                                                        disabled={!isSelected || process?.showLoading}
                                                        id={btnProcessId}
                                                        onClick={() => getSaleEditDetailDelete({ subMethod: 'btnDelete' })}>
                                                        <i className={settings?.icons?.fasFa?.cogs}></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.lastName?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.fasFa?.user} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            placeholder={labels?.lastName?.[languageObj?.id]}
                                                            value={formData.lastName}
                                                            title={labels?.lastName?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.email?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.[languageObj?.id] || settings?.icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            placeholder={labels?.email?.[languageObj?.id]}
                                                            value={formData.email}
                                                            title={labels?.email?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.quantity?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon text-right'
                                                            placeholder={labels?.quantity?.[languageObj?.id]}
                                                            value={setSeparatorsNumbersNew({
                                                                number: saleTotals.quantity,
                                                                withDecimals: true,
                                                                subMethod: currentMethod
                                                            })?.result}
                                                            title={labels?.quantity?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.priceOtherCurrency?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.dollarSign} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon text-right'
                                                            placeholder={labels?.priceOtherCurrency?.[languageObj?.id]}
                                                            value={setSeparatorsNumbersNew({
                                                                number: saleTotals.priceOC,
                                                                withDecimals: true,
                                                                subMethod: currentMethod
                                                            })?.result}
                                                            title={labels?.priceOtherCurrency?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-12 col-md-4'>
                                                <div className='form-group'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>
                                                        {labels?.price?.[languageObj?.id]}
                                                    </label>
                                                    <div className='position-relative'>
                                                        <i className={`${settings?.icons?.moneyBillWave} position-absolute input-icon-left`} />
                                                        <input type='text'
                                                            className='form-control border-0 shadow-sm form-input-icon text-right'
                                                            placeholder={labels?.price?.[languageObj?.id]}
                                                            value={setSeparatorsNumbersNew({
                                                                number: saleTotals.price,
                                                                withDecimals: true,
                                                                subMethod: currentMethod
                                                            })?.result}
                                                            title={labels?.price?.[languageObj?.id]}
                                                            readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div className={settings?.html?.cards?.default}>
                                    <LoadingSection alt='loadingSection'
                                        className='overlay dark text-white'
                                        height={20}
                                        hidden={!process?.showLoading}
                                        width={20}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header bg-white border-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt={labels?.sales?.[languageObj?.id]}
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={settings?.images?.icons?.store} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.sales?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={{ ...html?.badges?.micro }}>
                                                            <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-tools'>
                                                <button type='button'
                                                    className='btn btn-tool'
                                                    data-card-widget='collapse'>
                                                    <i className={settings?.icons?.fasFa?.minus} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='card-body pt-0'>
                                        <TableIndex tableId={dtSalesId} languageObj={languageObj} />
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {showModal && (
                        <SaleEditDetails processValues={{
                            ...saleEdited,
                            setSaleEdited,
                            setSaleEditedInit,
                            $,
                            auth,
                            showModal,
                            setShowModal,
                            dateTimeFormat,
                        }} />
                    )}
                </section>
                {/* /.content */}

            </div>
        </div>
    )
}
